export default __webpack_public_path__ + "static/media/nmp4.6dfc1ffd.png";